export {
    getPageTrackingData,
    ANALYTICS_BASE_TAXONOMY
} from './getPageTrackingData';
